import React from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';
import './Blog.css';

const blogArticles = [
    {
        id: 'what-is-gfrp-sariya',
        title: 'What is GFRP Sariya and Why It Is the Future of Construction',
        excerpt: 'Traditional steel reinforcement has been the backbone of construction for decades, but it comes with limitations—mainly corrosion, heavy weight, and long-term maintenance issues. Discover how GFRP Sariya is transforming the construction industry with superior performance and sustainability.',
        image: '/blog1.webp',
        date: '2025-01-15',
        readTime: '5 min read',
        featured: true
    },
    {
        id: 'gfrp-vs-steel-reinforcement',
        title: 'GFRP vs Steel Reinforcement: A Structural Comparison',
        excerpt: 'Choosing the right reinforcement material plays a crucial role in the longevity and safety of any structure. While steel has traditionally dominated the market, GFRP rebars are rapidly outperforming steel in critical parameters.',
        image: '/blog2.webp',
        date: '2025-04-22',
        readTime: '6 min read'
    },
    {
        id: 'applications-of-gfrp-sariya',
        title: 'Applications of GFRP Sariya in Modern Infrastructure',
        excerpt: 'GFRP sariya is revolutionizing infrastructure projects where durability and performance are non-negotiable. Its corrosion resistance makes it the preferred choice for bridges, flyovers, coastal structures, and marine construction.',
        image: '/blog3.webp',
        date: '2025-08-28',
        readTime: '5 min read'
    },
    {
        id: 'why-builders-switching-gfrp',
        title: 'Why Builders and Engineers Are Switching to GFRP Reinforcement',
        excerpt: 'The construction industry is evolving, and builders today prioritize materials that reduce risk, increase durability, and optimize costs. GFRP reinforcement checks all these boxes, which is why it is gaining rapid adoption across projects of all scales.',
        image: '/blog4.webp',
        date: '2025-11-05',
        readTime: '6 min read'
    }
];

function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

function Blog() {
    const featuredArticle = blogArticles[0];
    const regularArticles = blogArticles.slice(1);

    return (
        <div className="blog">
            <Navbar />

            {/* Blog Hero Section */}
            <div className="blog-hero-section">
                <div
                    className="blog-hero-background-overlay"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: 'url(/construction.webp)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.08,
                        zIndex: 1
                    }}
                />
                <div className="blog-hero-content">
                    <p className="blog-hero-tagline">Knowledge Hub</p>
                    <h1 className="blog-hero-title">GFRP Insights & Industry Expertise</h1>
                    <p className="blog-hero-subtitle">
                        Explore the latest developments in GFRP reinforcement technology, sustainable construction practices, and engineering innovations shaping the future of infrastructure.
                    </p>
                </div>
            </div>

            {/* Blog Articles */}
            <div className="blog-container">
                {/* Featured Article */}
                <div className="blog-featured-article">
                    <Link to={`/blog/${featuredArticle.id}`} className="blog-featured-card">
                        <div className="blog-featured-image-wrapper">
                            <img
                                src={featuredArticle.image}
                                alt={featuredArticle.title}
                                className="blog-featured-image"
                            />
                            <div className="blog-featured-badge">Featured Article</div>
                        </div>
                        <div className="blog-featured-content">
                            <div className="blog-featured-meta">
                                <span className="blog-featured-date">{formatDate(featuredArticle.date)}</span>
                                <span className="blog-featured-read-time">{featuredArticle.readTime}</span>
                            </div>
                            <h2 className="blog-featured-title">{featuredArticle.title}</h2>
                            <p className="blog-featured-excerpt">{featuredArticle.excerpt}</p>
                            <div className="blog-featured-read-more">
                                Read Full Article →
                            </div>
                        </div>
                    </Link>
                </div>

                {/* Section Divider */}
                <div className="blog-section-divider">
                    <h3 className="blog-section-title">Latest Articles</h3>
                </div>

                {/* Regular Articles Grid */}
                <div className="blog-articles-grid">
                    {regularArticles.map((article) => (
                        <Link
                            to={`/blog/${article.id}`}
                            key={article.id}
                            className="blog-article-card"
                        >
                            <div className="blog-article-image-wrapper">
                                <img
                                    src={article.image}
                                    alt={article.title}
                                    className="blog-article-image"
                                />
                            </div>
                            <div className="blog-article-content">
                                <div className="blog-article-meta">
                                    <span className="blog-article-date">{formatDate(article.date)}</span>
                                    <span className="blog-article-read-time">{article.readTime}</span>
                                </div>
                                <h2 className="blog-article-title">{article.title}</h2>
                                <p className="blog-article-excerpt">{article.excerpt}</p>
                                <div className="blog-article-read-more">
                                    Read More →
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default Blog;